import classNames from 'classnames';
import React, { useState } from 'react';
import {
	Button as AriaButton,
	CalendarCell,
	CalendarGrid,
	CalendarGridBody,
	DateRangePicker,
	Heading,
	Label,
	RangeCalendar,
} from 'react-aria-components';
import { useSelector } from 'react-redux';
import Button from '../../../../components/Button';
import Icon, { Icons } from '../../../../components/Icon/Icon';
import { t } from '../../../../lang';
import HelperService from '../../../../services/HelperService';
import { createRootModal } from '../../RootModal';

import './PeriodSelectModal.scss';

const ARROW_SIZE = 20;

const weekDays = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];

const PeriodSelectModal = createRootModal(() => {
	const { selectPeriod } = useSelector(state => state.app.modal.outsideParams);
	const [period, setPperiod] = useState();

	const dateFrom = period && new Date(Date.UTC(period.start.year, period.start.month - 1, period.start.day));
	const dateTo = period && new Date(Date.UTC(period.end.year, period.end.month - 1, period.end.day));

	const dateFromShow = period ? HelperService.formatDate(dateFrom, '.', 10, '', false, true) : t('Start date');
	const dateToShow = period ? HelperService.formatDate(dateTo, '.', 10, '', false, true) : t('end date');

	const apply = () => {
		selectPeriod(dateFrom, dateTo);
	};

	const isDayToday = date => {
		const now = new Date();
		return now.getFullYear() === date.year && now.getMonth() + 1 === date.month && now.getDate() === date.day;
	};

	return (
		<div className='PeriodSelectModal'>
			<DateRangePicker onChange={setPperiod}>
				<Label />
				<RangeCalendar firstDayOfWeek='mon' aria-label='Event date'>
					<header className='PeriodSelectModal__header'>
						<AriaButton slot='previous'>
							<Icon type={Icons.NEXT_ARROW} width={ARROW_SIZE} height={ARROW_SIZE} />
						</AriaButton>
						<div>
							{dateFromShow} - {dateToShow}
						</div>
						<AriaButton slot='next'>
							<Icon type={Icons.NEXT_ARROW} width={ARROW_SIZE} height={ARROW_SIZE} />
						</AriaButton>
					</header>
					<div className='PeriodSelectModal__week-days'>
						{weekDays.map(dayName => (
							<div className='PeriodSelectModal__week-day' key={dayName}>
								{t(dayName)}
							</div>
						))}
					</div>
					<Heading />
					<CalendarGrid>
						<CalendarGridBody>
							{date => (
								<CalendarCell date={date}>
									{({ formattedDate }) => (
										<div
											className={classNames('PeriodSelectModal__CalendarCell-content', {
												PeriodSelectModal__today: isDayToday(date),
											})}
										>
											{formattedDate}
										</div>
									)}
								</CalendarCell>
							)}
						</CalendarGridBody>
					</CalendarGrid>
				</RangeCalendar>
			</DateRangePicker>
			<footer className='PeriodSelectModal__footer'>
				<Button onClick={apply} disabled={!period}>
					{t('Apply')}
				</Button>
			</footer>
		</div>
	);
});

export default PeriodSelectModal;
